/* eslint-disable camelcase */
import { toast } from 'react-toastify';
import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import ToastComponent from '../../components/toast';
import {
  TradePreClearanceApprovalService,
  type Wealthlane_AwardService_Dtos_Response_ResponseDto,
} from '@wealthlane/api-services/wealthlane-award-service';

const usePostPreClearanceRequestReject = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  closeRejectModal: () => void,
  closeModal: () => void
): UseMutationResult<
  Wealthlane_AwardService_Dtos_Response_ResponseDto | undefined,
  unknown,
  any,
  unknown
> => {
  const queryClient = useQueryClient();
  return useMutation(
    async (payload: any) => {
      return await handleRequest(
        TradePreClearanceApprovalService.postApiAwardApiAppTradePreClearanceApprovalRejectPreClearanceRequest(
          payload
        )
      );
    },
    {
      onSuccess: async (
        response: Wealthlane_AwardService_Dtos_Response_ResponseDto | undefined
      ) => {
        if (response != null) {
          await queryClient.invalidateQueries('getPreClearanceRequestList');
          closeRejectModal();
          closeModal();
          toast.success(<ToastComponent label='Success' message='Pre Clearance Rejected.' />);
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostPreClearanceRequestReject;
